"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _card = require("../../styles/card"),
    _Icon = _interopRequireDefault(require("../../../../../Icon")),
    _ActionPopup = _interopRequireDefault(require("../../../../../ActionPopup")),
    Actions = function Actions(a) {
  var b = a.color,
      c = a.options;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("card_overlay__popup-container", _card.CARD_OVERLAY_MORE_ICON)
  }, _react["default"].createElement(_ActionPopup["default"], {
    popupBtn: _react["default"].createElement(_Icon["default"], {
      color: b,
      name: "options"
    }),
    options: c
  }));
},
    _default = Actions;

exports["default"] = _default;